import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Platform, Pressable } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { url } from '../../../constants/DevProd';
import { BackgroundGradient, Loader, Storage } from '../../../components';
import * as rtApi from '../../../components/Api';
import UserState from '../../../src/contexts/UserState';
import { FontAwesome, Entypo, MaterialIcons, Feather, MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons';
import Svg, { Path, SvgUri, G } from 'react-native-svg';
import { useLinkTo } from '@react-navigation/native';
import * as WebBrowser from 'expo-web-browser';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const PaymentMethodScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);

  const [loading, setLoading] = React.useState(false);
  // const [milestone, setMilestone] = React.useState({});
  const [paymentMethods, setPaymentMethods] = React.useState([]);
  const insets = useSafeAreaInsets();

  const linkTo = useLinkTo();

  React.useEffect(() => {
    getMoney()
    return () => rtApi.cancel();
  }, []);

  const getMoney = () => {
    setLoading(true);
    rtApi.get('money')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('getMoney(): ', data);
      if(data.unassigned_funds > 0){
        // account balance at top
        if (route.params.acceptCreditCards === 'No') {
          // hide credit card
          setPaymentMethods([
            paymentMethodData.accountBalance,
            paymentMethodData.billPayment,
            paymentMethodData.eTransfer,
            paymentMethodData.wireTransfer,
            paymentMethodData.localBranch,
            paymentMethodData.mailCheque,
          ]);
        }else{
          // show credit card
          setPaymentMethods([
            paymentMethodData.accountBalance,
            paymentMethodData.billPayment,
            paymentMethodData.eTransfer,
            paymentMethodData.creditCard,
            paymentMethodData.wireTransfer,
            paymentMethodData.localBranch,
            paymentMethodData.mailCheque,
          ]);
        }
      }else{
        // account balance at bottom
        if (route.params.acceptCreditCards === 'No') {
          // hide credit card
          setPaymentMethods([
            paymentMethodData.billPayment,
            paymentMethodData.eTransfer,
            paymentMethodData.wireTransfer,
            paymentMethodData.localBranch,
            paymentMethodData.mailCheque,
            paymentMethodData.accountBalance,
          ]);
        }else{
          // show credit card
          setPaymentMethods([
            paymentMethodData.billPayment,
            paymentMethodData.eTransfer,
            paymentMethodData.creditCard,
            paymentMethodData.wireTransfer,
            paymentMethodData.localBranch,
            paymentMethodData.mailCheque,
            paymentMethodData.accountBalance,
          ]);
        }
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  const selectPaymentMethod = async (method) => {
    console.log('selectPaymentMethod: ', method);
    method = method.toLowerCase().replace(/ /g, '_').replace(/-/g, '_');
    // if (method === 'credit_or_debit_card'){
    //   const rtJWT = await Storage.getItem('rtJWT');
    //   let result = await WebBrowser.openAuthSessionAsync(`${url.base}credit_card?jwt=${rtJWT}&stage_id=${route.params.milestoneId}`);
    //   // window.location.reload();
    //   linkTo('/projects');
    // }else{
      linkTo(`/project/${route.params.projectId}/milestone/${route.params.milestoneId}/payment/${method}`)
    // }
    
    // RootNavigation.navigate('Payment', {
    //   milestone: route.params.milestone,
    //   paymentMethod: method,
    //   projectId: route.params.projectId,
    //   whoPays: route.params.whoPays,
    // });
  }

  const shieldMoney = () => {
    return (
      <View style={styles.iconAbsoluteContainer}>
        <MaterialCommunityIcons name="shield" size={48} color={Colors.lightBlue2} />
        <MaterialIcons name="attach-money" size={36} color={Colors.textInputBackground} style={styles.iconAbsolute} />
      </View>
    )
  }
  const eTransferIcon = () => {
    if(Platform.OS === 'web'){
      return (
        <Svg
          viewBox="0 0 169 169"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit={2}
        >
          <Path
            d="M14.028 0h140.277c7.696 0 14.029 6.333 14.029 14.029v140.279c0 7.696-6.332 14.028-14.028 14.028H14.026C6.332 168.336 0 162.005 0 154.31V14.028C0 6.333 6.333 0 14.028 0zm15.366 102.212c0-2.984-2.455-5.44-5.438-5.44-2.984 0-5.44 2.456-5.44 5.44l.01 45.189c.01 8.07 6.645 14.71 14.716 14.726 4.117 0 15.395-.02 15.395-.02l.005-18.852.005-21.023a7.124 7.124 0 00-3.163-5.927l-13.721-9.32-.003 21.163c0 .642-.528 1.17-1.17 1.17-.642 0-1.17-.528-1.17-1.17 0-.227-.026-23.141-.026-25.936zM8.78 139.042c-2.65-.001-4.83-2.18-4.831-4.828a4.758 4.758 0 01.778-2.627l.054-.087 11.469-2.703v8.64l-.177.047c-2.726.656-5.753 1.34-6.301 1.46a5.087 5.087 0 01-.992.099zm0-11.075c-2.65 0-4.83-2.177-4.831-4.825a4.771 4.771 0 01.778-2.627l.054-.081.09-.023 11.379-2.685v8.64l-.177.047c-2.581.619-5.666 1.334-6.301 1.46a5.006 5.006 0 01-.992.094zm0-11.054c-2.652-.003-4.831-2.185-4.831-4.837 0-.933.27-1.847.778-2.631l.054-.07.09-.024 11.379-2.686v8.64l-.177.042a396.424 396.424 0 01-6.301 1.463 4.733 4.733 0 01-.992.103zm-1.343-10.588l-.003-48.35 8.815-2.082v48.348l-8.812 2.084zm29.3-37.83a11.9 11.9 0 00-7.845 6.067v-3.398l-7.937 1.878.009 21.7a8.13 8.13 0 018.357 1.46v-14.01c0-3.356 1.67-6.037 4.056-6.563 1.795-.394 3.294.248 3.294 3.445l.006 20.442 8.36-1.96V75.93c0-5.243-2.02-8.908-8.3-7.435zm15.78 27.29s-1.278-1.917-1.278-8.698V72.08l-4.048.963V66.86l4.057-.958v-6.74l8.365-1.975v6.739l5.91-1.404v6.175l-5.91 1.403s-.01 12.295 0 15.28c0 6.949 1.844 8.283 1.844 8.283l-8.94 2.122zm13.88-17.93c0-5.357.764-9.266 2.402-12.266 1.949-3.56 5.145-5.88 9.8-6.94 9.178-2.087 12.49 3.345 12.362 10.629-.05 2.605-.037 3.874-.037 3.874l-16.168 3.8v.26c0 5.09 1.067 7.505 4.292 6.82 2.786-.587 3.56-2.332 3.78-4.49.037-.348.054-1.233.054-1.233l7.574-1.815s.018.62.007 1.316c-.066 2.892-.907 10.066-11.434 12.555-9.972 2.367-12.631-3.723-12.631-12.51zm27.592 8.13l-.014-30.14 7.867-1.866v3.95s2.038-5.195 6.767-6.401a4.536 4.536 0 012.188-.147v7.69c-1.416.019-2.815.31-4.122.858-2.907 1.148-4.37 3.653-4.37 7.477l.005 16.642-8.321 1.937zm17.425-12.903c0-6.982 4.09-9.19 10.246-11.737 5.536-2.29 5.656-3.427 5.679-5.417.03-1.675-.746-3.108-3.502-2.405a4.17 4.17 0 00-3.336 3.943 14.263 14.263 0 00-.052 1.547l-7.762 1.833a15.43 15.43 0 01.536-4.586c1.24-4.175 4.923-6.984 11.279-8.455 8.258-1.903 11.01 1.72 11.02 7.358v13.349c0 6.456 1.199 7.402 1.199 7.402l-7.62 1.803a16.465 16.465 0 01-1.021-2.737c-.26-.941-1.67 4.204-7.423 5.556-6.043 1.425-9.243-2.32-9.243-7.454zm15.872-9.534a28.758 28.758 0 01-4.054 2.374c-2.54 1.24-3.688 2.772-3.688 5.13 0 2.042 1.265 3.383 3.564 2.815 2.466-.622 4.178-2.923 4.178-6.12v-4.2zm11.824-3.317c-.313-9.18 2.068-16.464 12.309-18.784 6.527-1.483 9.006.215 10.26 1.856 1.208 1.566 1.674 3.678 1.674 6.636l.007.543-8.012 1.904-.006-1.115c.006-3.508-.97-4.842-3.517-4.204-3.03.76-4.254 3.637-4.254 9.355 0 2.03.009 2.394.009 2.668 0 5.81.794 8.47 4.286 7.74 3.029-.626 3.444-3.286 3.493-5.618.006-.366.02-1.538.02-1.538l8-1.89s.009.59.009 1.248c-.02 7.62-4.036 12.422-11.56 14.173-10.366 2.43-12.396-3.56-12.718-12.974zm-60.174 4.032c-2.68.608-4.084 3.236-4.145 7.59l8.133-1.937c.014-.197.016-.631.014-1.311-.014-3.287-1.03-5.022-4.002-4.342zm79.268-26.711h-.005c-2.834 0-5.167-2.333-5.167-5.168 0-2.834 2.333-5.167 5.167-5.167 2.835 0 5.168 2.333 5.168 5.167v.003c-.003 2.832-2.331 5.16-5.163 5.165zm0-9.685h-.001c-2.48 0-4.52 2.04-4.52 4.519s2.04 4.519 4.52 4.519c2.479 0 4.518-2.04 4.519-4.518-.002-2.478-2.04-4.517-4.518-4.52zm-1.882 1.44h2.227a1.464 1.464 0 011.601 1.621c0 .819-.363 1.448-1.051 1.555v.012c.626.064.955.409.987 1.296.012.4.018.896.037 1.282 0 .22.114.426.299.545h-1.138a1.06 1.06 0 01-.17-.56c-.035-.377-.026-.733-.043-1.191-.017-.688-.228-.99-.92-.99h-.823v2.74h-1.006v-6.31zm1.812 2.81a.932.932 0 001.007-1.023c0-.672-.291-1.026-.954-1.026h-.86v2.05h.807z"
            fill="#91b7fe"
          />
        </Svg>
      )
    }
    return (
      <SvgUri width='40' height='40' uri={`${url.base}img/svg/InteracLogo_lightBlue2.svg`} />
    );
  }
  const wireTransferIcon = () => {
    if(Platform.OS === 'web'){
      return (
        <Svg
          viewBox="0 0 29 26"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit={2}
          rotation={-45}
        >
          <G fill="#91b7fe" fillRule="nonzero">
            <Path d="M27.45 16.538c-.49 0-.89-.4-.89-.89 0-3.42-2.78-6.2-6.2-6.2H11.8v3.84c0 .78-.94 1.17-1.5.64l-6.49-6.2a.91.91 0 01-.27-.64c0-.24.1-.47.27-.64l6.49-6.2c.56-.54 1.5-.14 1.5.64v3.84h7.38c5.05 0 9.15 4.11 9.15 9.15v1.77c.01.5-.39.89-.88.89z" />
            <Path d="M16.53 25.098v-3.84H9.15c-5.05 0-9.15-4.11-9.15-9.15v-1.77c0-.49.4-.89.89-.89s.89.4.89.89c0 3.42 2.78 6.2 6.2 6.2h8.56v-3.84c0-.78.93-1.18 1.5-.64l6.49 6.2c.17.17.27.4.27.64s-.1.47-.27.64l-6.49 6.2c-.57.54-1.51.14-1.51-.64z" />
          </G>
        </Svg>
      )
    }
    return (
      <SvgUri width='40' height='40' uri={`${url.base}img/svg/wire_transfer.svg`} style={{ transform: [{ rotate: '-45deg' }] }} />
    )
  }

  const paymentMethodData = {
    billPayment: {
      type: 'Bill Payment',
      time: '1 business day',
      description: "Use your bank's online bill payment",
      icon: <FontAwesome5 name="file-invoice-dollar" size={36} color={Colors.lightBlue2} />,
    },
    eTransfer: {
      type: 'e-transfer',
      time: '30 mins - 1 business day',
      description: 'Email the funds',
      // icon: <FontAwesome name="bank" size={36} color={Colors.lightBlue2} />,
      icon: eTransferIcon(),
    },
    creditCard: {
      type: 'Credit or Debit Card',
      time: '30 mins - 1 business day | Instant',
      description: 'Quickest Way',
      icon: <FontAwesome name="credit-card" size={36} color={Colors.lightBlue2} />,
    },
    wireTransfer: {
      type: 'Wire Transfer',
      time: '2 - 5 business days',
      description: 'Better for moving large sums',
      // icon: <FontAwesome name="refresh" size={36} color={Colors.lightBlue2} style={{ transform: [{ rotate: '-45deg' }] }} />,
      icon: wireTransferIcon(),
    },
    localBranch: {
      type: 'Deposit at Your Local CIBC Branch',
      time: '1 business day',
      description: 'Requires visiting your local CIBC branch',
      icon: <FontAwesome name="bank" size={36} color={Colors.lightBlue2} />,
    },
    mailCheque: {
      type: 'Mail a Cheque',
      time: '10+ business days',
      // description: '',
      icon: <FontAwesome5 name="money-check-alt" size={36} color={Colors.lightBlue2} />,
    },
    accountBalance: {
      type: 'Account Balance',
      time: 'Instant',
      description: 'Use the funds in your account',
      icon: shieldMoney(),
    },
  };

  const paymentMethod = (pm, i) => {
    return (
      <TouchableOpacity style={styles.paymentMethodContainer} activeOpacity={0.6} onPress={() => selectPaymentMethod(pm.type)} key={i}>
        <View style={styles.iconContainer}>
          {pm.icon}
        </View>
        <View style={styles.methodText}>
          <Text style={[CS.mediumText, CS.lightText, CS.boldText, styles.mBottom]}>{pm.type}</Text>
          <Text style={[CS.smallText, CS.lightText, CS.boldText]}>{pm.time}</Text>
          {pm.description &&
            <Text style={[CS.miniText, CS.lightBlueText, styles.mTop]}>{pm.description}</Text>
          }
        </View>
        <Entypo name="chevron-thin-right" size={28} color={Colors.lightBlue2} />
      </TouchableOpacity>
    )
  }
  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/project/${route.params.projectId}/milestone/${route.params.milestoneId}`);
    }
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <View style={CS.innerContainer}>
        
        {/* screen content */}
        <ScrollView contentContainerStyle={{ paddingTop: insets.top, paddingBottom: insets.bottom }}>
          <Pressable onPress={goBack} style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0, marginVertical: 10 }]} hitSlop={10}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </Pressable>
          <Text style={[CS.mediumTitle, CS.lightText, { marginBottom: 5, marginTop: 0 }]}>Choose a funding method</Text>
          {paymentMethods.map((pm, i) => {
            return paymentMethod(pm, i)
          })}
          <Text style={[CS.miniText, CS.lightBlueText, { marginBottom: 10 }]}>Additional fees may apply, depending on your bank, relationship and account type</Text>
        </ScrollView>
      </View>
    </View>
  );

}

const styles = StyleSheet.create({
  paymentMethodContainer: {
    flexDirection: 'row',
    // flex: 1,
    alignItems: 'center',
    marginVertical: 10,
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding: 10,
    borderRadius: 10,
    backgroundColor: Colors.textInputBackground,
  },
  mBottom: {
    marginBottom: 5,
  },
  mTop: {
    marginTop: 5,
  },
  methodText: {
    marginHorizontal: 10,
    flex: 1,
  },
  iconContainer: {
    width: 68,
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: 'red',
    paddingHorizontal: 10,
  },
  iconAbsoluteContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconAbsolute: {
    position: 'absolute',
    paddingLeft: 1
  }
});

export default PaymentMethodScreen;